<template>
  <section
    class="background"
    :class="{ 'background--white-label': showCustomBackground }"
  >
    <article class="printable-reward-link-redemption-page-main-section">
      <printable-reward-link-redemption-instructions
        :reward-name="rewardNameToDisplay"
        :icon-color="iconColorToDisplay"
      />
      <printable-reward-link-redemption-form
        :is-loading="formIsLoading"
        :error-message="errorMessage"
        @submit="onFormSubmit"
      />
      <captcha-policy
        id="printed-rl-captcha-policy"
      />
    </article>
  </section>
</template>

<script>
import PrintableRewardLinkRedemptionInstructions from './PrintableRewardLinkRedemptionInstructions'
import PrintableRewardLinkRedemptionForm from './PrintableRewardLinkRedemptionForm'
import { LandingPageCustomization } from '../customization/LandingPageCustomization'
import CaptchaPolicy from '@/components/shared/captcha/CaptchaPolicy'

export default {
  name: 'PrintableRewardLinkRedemptionPageMainSection',
  components: {
    PrintableRewardLinkRedemptionForm,
    PrintableRewardLinkRedemptionInstructions,
    CaptchaPolicy
  },
  props: {
    formIsLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    errorMessage: {
      type: String,
      required: false,
      default: ''
    },
    landingPageCustomization: {
      type: LandingPageCustomization,
      required: false,
      default: null
    }
  },
  computed: {
    showCustomBackground () {
      return !!this.landingPageCustomization
    },
    rewardNameToDisplay () {
      return this.safelyGetPropertyFromLandingPageCustomization('rewardName')
    },
    iconColorToDisplay () {
      return this.safelyGetPropertyFromLandingPageCustomization(
        'backgroundColor'
      )
    }
  },
  methods: {
    onFormSubmit (codePayload) {
      this.$emit('submit', codePayload)
    },
    safelyGetPropertyFromLandingPageCustomization (propertyName) {
      return this.landingPageCustomization
        ? this.landingPageCustomization[propertyName]
        : null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';

$main-section-width: 710px;

.printable-reward-link-redemption-page-main-section {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  max-width: $main-section-width;
  padding: 45px 20px 0;
}

.background {
  height: 100%;
  width: 100%;
  min-height: 420px;
  display: flex;
  justify-content: center;
  background-image: url('../../assets/images/printable/printable_redeem_landing_page_desktop.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.background--white-label {
  background-image: url('../../assets/images/printable/white_label_redeem_landing_page_desktop.png');
}

@media screen and (max-width: $breakpoint-md - 1) {
  .background {
    background-position: center bottom -200px;
    background-image: url('../../assets/images/printable/printable_redeem_landing_page_tablet.png');
  }

  .background--white-label {
    background-image: url('../../assets/images/printable/white_label_redeem_landing_page_tablet.png');
  }
}

@media screen and (max-width: $breakpoint-sm - 1) {
  .background {
    background-image: url('../../assets/images/printable/printable_redeem_landing_page_mobile.png');
  }

  .background--white-label {
    background-image: url('../../assets/images/printable/white_label_redeem_landing_page_mobile.png');
  }
}

#printed-rl-captcha-policy {
  margin-top: auto;
  padding: 45px 0 0;
}

#printed-rl-captcha-policy ::v-deep a {
  color: $tangoTextPrimary;
  text-decoration: underline !important;
}

</style>
